import { dataService } from '../../data';

import { DataObject, ObjectOptions, RelatedObject } from "../base";
import { CreateObject } from "../item";

/****************************/
/* SCHEMA DEFINITION        */
/****************************/

import { TicketType } from '../types';
import { ClientType } from '../types';

import { Ticket } from './ticket';

const _schema = {
    "name": "TICKETINVOICE",
    "fields": [
        { name: "status", type: "string", default: "AC" },
        { name: "ticket", type: "objid" },
        { name: "client", type: "objid" }
    ],
    relate: [
        { direction: ">", target: "TICKET", by: "ticket", name: "ticket", reason: "ticket", child: false, class: TicketType },
        { direction: ">", target: "INVOICEBUSINESS", by: "client", name: "client", reason: "client", child: false, class: ClientType }
    ]
} as const;

const _TicketInvoiceClass = CreateObject(_schema);
if (!_TicketInvoiceClass) {
    throw new Error("Failed to create BaseClass for '" + _schema.name + "'");
}

/****************************/
/* CLASS DECLARATION        */
/****************************/

export class TicketInvoice extends _TicketInvoiceClass { 
    constructor(objid: string | null, data: dataService, objoptions: ObjectOptions | null = null){
        super(_schema, objid, data, objoptions || {});
    }

    Copy(store: Array<DataObject> = []): TicketInvoice {
        return this._Copy(store) as TicketInvoice;
    }

    /** Changelog rows lack `TICKET.invoices`; register on link (see TicketProduct). */
    protected override DoChildLinked(relation: string | null, related: RelatedObject | null): void {
        if (this.CopyOf || relation !== 'ticket' || !(related instanceof Ticket)){
            return;
        }

        if (related === this.ticket){
            related.AddInvoice(this);
        }
        else {
            related.DelInvoice(this);
        }
    }

    /****************************/
    /* CLASS MEMBERS            */
    /****************************/
    
    get status(): string | null {
        return this['__base__status'];
    }

    set status(value: string){
        if (this.status == 'DE'){
            return;     // cannot modify deleted items
        }

        if (this.status == value){
            return;
        }

        this['__base__status'] = value;
        if (this.ticket){
            if ((this.status == 'DE') && !this.Commited){
                this.ticket.DelInvoice(this);
            }
            else {
                this.ticket.DoRefresh(this.table);
            }    
        }
    }    

    get business(): string | null {
        return this.client?.name || null;
    }

    get taxid(): string | null {
        return this.client?.taxid || null;
    }

    get address(): string | null {
        return this.client?.address || null;
    }

    get postal(): string | null {
        return this.client?.postal || null;
    }

    get region(): string | null {
        return this.client?.region || null;
    }
    
    /****************************/
    /* CUSTOM METHODS           */
    /****************************/

    get IsValid(): boolean {
        return (!!this.status && (this.status != 'DE'));
    }    
}
